import EventBoxText from '../components/EventBoxText';

type Props = {
  color: string;
  hoverColor: string;
  hoverComponent: any;
};
type Result = (text: string, bold?: boolean) => JSX.Element;
const getRenderBoxLine = (props: Props): Result => {
  const { color, hoverColor, hoverComponent } = props;
  const renderBoxLine = (text: string, bold = false): JSX.Element => (
    <EventBoxText bold={bold} color={color} hoverColor={hoverColor} hoverComponent={hoverComponent}>
      {text}
    </EventBoxText>
  );
  return renderBoxLine;
};

export default getRenderBoxLine;
